/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateSensor = /* GraphQL */ `
  subscription OnCreateSensor($filter: ModelSubscriptionSensorFilterInput) {
    onCreateSensor(filter: $filter) {
      id
      apiGroupId
      groupId
      managementId
      name
      status
      lat
      lng
      location
      description
      tx
      isLocked
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSensor = /* GraphQL */ `
  subscription OnUpdateSensor($filter: ModelSubscriptionSensorFilterInput) {
    onUpdateSensor(filter: $filter) {
      id
      apiGroupId
      groupId
      managementId
      name
      status
      lat
      lng
      location
      description
      tx
      isLocked
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSensor = /* GraphQL */ `
  subscription OnDeleteSensor($filter: ModelSubscriptionSensorFilterInput) {
    onDeleteSensor(filter: $filter) {
      id
      apiGroupId
      groupId
      managementId
      name
      status
      lat
      lng
      location
      description
      tx
      isLocked
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateSensorGroup = /* GraphQL */ `
  subscription OnCreateSensorGroup(
    $filter: ModelSubscriptionSensorGroupFilterInput
  ) {
    onCreateSensorGroup(filter: $filter) {
      id
      name
      type
      messages {
        status
        message
        color
        value
        notification
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSensorGroup = /* GraphQL */ `
  subscription OnUpdateSensorGroup(
    $filter: ModelSubscriptionSensorGroupFilterInput
  ) {
    onUpdateSensorGroup(filter: $filter) {
      id
      name
      type
      messages {
        status
        message
        color
        value
        notification
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSensorGroup = /* GraphQL */ `
  subscription OnDeleteSensorGroup(
    $filter: ModelSubscriptionSensorGroupFilterInput
  ) {
    onDeleteSensorGroup(filter: $filter) {
      id
      name
      type
      messages {
        status
        message
        color
        value
        notification
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateNotification = /* GraphQL */ `
  subscription OnCreateNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onCreateNotification(filter: $filter) {
      id
      startDate
      endDate
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateNotification = /* GraphQL */ `
  subscription OnUpdateNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onUpdateNotification(filter: $filter) {
      id
      startDate
      endDate
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteNotification = /* GraphQL */ `
  subscription OnDeleteNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onDeleteNotification(filter: $filter) {
      id
      startDate
      endDate
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCameraTrafficVolume = /* GraphQL */ `
  subscription OnCreateCameraTrafficVolume(
    $filter: ModelSubscriptionCameraTrafficVolumeFilterInput
  ) {
    onCreateCameraTrafficVolume(filter: $filter) {
      cameraId
      timestamp
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCameraTrafficVolume = /* GraphQL */ `
  subscription OnDeleteCameraTrafficVolume(
    $filter: ModelSubscriptionCameraTrafficVolumeFilterInput
  ) {
    onDeleteCameraTrafficVolume(filter: $filter) {
      cameraId
      timestamp
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUserDeviceGroups = /* GraphQL */ `
  subscription OnCreateUserDeviceGroups(
    $filter: ModelSubscriptionUserDeviceGroupsFilterInput
  ) {
    onCreateUserDeviceGroups(filter: $filter) {
      userId
      group1 {
        name
        __typename
      }
      group2 {
        name
        __typename
      }
      group3 {
        name
        __typename
      }
      group4 {
        name
        __typename
      }
      group5 {
        name
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserDeviceGroups = /* GraphQL */ `
  subscription OnUpdateUserDeviceGroups(
    $filter: ModelSubscriptionUserDeviceGroupsFilterInput
  ) {
    onUpdateUserDeviceGroups(filter: $filter) {
      userId
      group1 {
        name
        __typename
      }
      group2 {
        name
        __typename
      }
      group3 {
        name
        __typename
      }
      group4 {
        name
        __typename
      }
      group5 {
        name
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserDeviceGroups = /* GraphQL */ `
  subscription OnDeleteUserDeviceGroups(
    $filter: ModelSubscriptionUserDeviceGroupsFilterInput
  ) {
    onDeleteUserDeviceGroups(filter: $filter) {
      userId
      group1 {
        name
        __typename
      }
      group2 {
        name
        __typename
      }
      group3 {
        name
        __typename
      }
      group4 {
        name
        __typename
      }
      group5 {
        name
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateTrafficMonitoring = /* GraphQL */ `
  subscription OnCreateTrafficMonitoring(
    $filter: ModelSubscriptionTrafficMonitoringFilterInput
  ) {
    onCreateTrafficMonitoring(filter: $filter) {
      type
      routeId
      routeName
      routeDataKey
      trafficDirections
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTrafficMonitoring = /* GraphQL */ `
  subscription OnUpdateTrafficMonitoring(
    $filter: ModelSubscriptionTrafficMonitoringFilterInput
  ) {
    onUpdateTrafficMonitoring(filter: $filter) {
      type
      routeId
      routeName
      routeDataKey
      trafficDirections
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTrafficMonitoring = /* GraphQL */ `
  subscription OnDeleteTrafficMonitoring(
    $filter: ModelSubscriptionTrafficMonitoringFilterInput
  ) {
    onDeleteTrafficMonitoring(filter: $filter) {
      type
      routeId
      routeName
      routeDataKey
      trafficDirections
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateAggregatedTrafficVolume = /* GraphQL */ `
  subscription OnCreateAggregatedTrafficVolume(
    $filter: ModelSubscriptionAggregatedTrafficVolumeFilterInput
  ) {
    onCreateAggregatedTrafficVolume(filter: $filter) {
      cameraId
      bucketTime
      scenario_1_count
      scenario_2_count
      scenario_3_count
      scenario_4_count
      scenario_5_count
      scenario_6_count
      scenario_7_count
      scenario_8_count
      scenario_9_count
      scenario_10_count
      scenario_11_count
      scenario_12_count
      scenario_13_count
      scenario_14_count
      scenario_15_count
      scenario_16_count
      scenario_17_count
      scenario_18_count
      scenario_19_count
      scenario_20_count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAggregatedTrafficVolume = /* GraphQL */ `
  subscription OnUpdateAggregatedTrafficVolume(
    $filter: ModelSubscriptionAggregatedTrafficVolumeFilterInput
  ) {
    onUpdateAggregatedTrafficVolume(filter: $filter) {
      cameraId
      bucketTime
      scenario_1_count
      scenario_2_count
      scenario_3_count
      scenario_4_count
      scenario_5_count
      scenario_6_count
      scenario_7_count
      scenario_8_count
      scenario_9_count
      scenario_10_count
      scenario_11_count
      scenario_12_count
      scenario_13_count
      scenario_14_count
      scenario_15_count
      scenario_16_count
      scenario_17_count
      scenario_18_count
      scenario_19_count
      scenario_20_count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAggregatedTrafficVolume = /* GraphQL */ `
  subscription OnDeleteAggregatedTrafficVolume(
    $filter: ModelSubscriptionAggregatedTrafficVolumeFilterInput
  ) {
    onDeleteAggregatedTrafficVolume(filter: $filter) {
      cameraId
      bucketTime
      scenario_1_count
      scenario_2_count
      scenario_3_count
      scenario_4_count
      scenario_5_count
      scenario_6_count
      scenario_7_count
      scenario_8_count
      scenario_9_count
      scenario_10_count
      scenario_11_count
      scenario_12_count
      scenario_13_count
      scenario_14_count
      scenario_15_count
      scenario_16_count
      scenario_17_count
      scenario_18_count
      scenario_19_count
      scenario_20_count
      createdAt
      updatedAt
      __typename
    }
  }
`;
